import React from 'react';
import Image from 'src/components/Image';

import { DemoTemplate } from 'src/templates';

import { metaData, pageHeaderBIData } from 'src/store/accounts';

const Accounts = () => {
  return (
    <DemoTemplate {...metaData}>
      <div className='page-header-longer background background--color-black100'>
        <div className='nav-spacer' />
        <div className='grid-container'>
          <div className='grid-x align-justify grid-margin-x'>
            <div className='cell small-12 medium-4'>
              <div className='grid-x'>
                <div className='cell small-12 page-header-breakpoint-12'>
                  <h1 className='page-header-header'>
                    {pageHeaderBIData.status}
                  </h1>
                  <h4 className='regular page-header-subheader'>
                    {pageHeaderBIData.subtext}
                  </h4>
                </div>
              </div>
            </div>
            <div className='cell small-12 medium-8 page-header-bg-wrapper'>
              <div>
                <div className='demo-accent'>
                  <Image
                    src='https://images.ctfassets.net/ss5kfr270og3/3rdsesKs5mC5bNKBlUWfAk/cd07dad6bcee7d1f4e13ecebda0e4816/homepage-howitworks-brushstroke-left.png?fm=webp&q=70'
                    alt=''
                  />
                </div>
                <div className='code-container code-container--tall code-container--z-index code-container--double'>
                  <header className='code-container-header'>
                    <p className='code-container-header-title'>
                      POST /credit/bank_income/get response
                    </p>
                    <div
                      // data-toggle-code-example=''
                      className='button-code-toggle-wrapper'
                    >
                      <button className='button button-code-toggle clear'>
                        JSON
                      </button>
                    </div>
                  </header>
                  <div className='code-container-body code-product-example'>
                    <div className='code-example is-active'>
                      <pre>
                        {' '}
                        <code
                          id='bank-income-get-response'
                          className='language-json'
                        >{`
                  `}</code>
                      </pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DemoTemplate>
  );
};

export default Accounts;
